import React, { PureComponent } from 'react'
import styled, { css } from 'styled-components'
import qs from 'qs'

import { slack } from 'gipsy-api'
import { styles, translations } from 'gipsy-misc'
import { media } from 'gipsy-ui'

import { getSrc } from 'utils/image'

class SlackLandingPage extends PureComponent {
  state = {
    slackAuthUrl: '',
    showInstalled: false
  }

  componentDidMount = () => {
    const queryParams = qs.parse(this.props.location.search, { ignoreQueryPrefix: true })

    if (queryParams.installed) {
      this.setState({
        showInstalled: true
      })
    }

    this.fetchSlackAuthUrl(queryParams.teamId)
  }

  fetchSlackAuthUrl = async teamId => {
    const slackAuthUrl = await slack.getAuthURL(teamId)

    this.setState({ slackAuthUrl })
  }

  render() {
    const { showInstalled, slackAuthUrl } = this.state
    return (
      <Container className="slack-login-page">
        {showInstalled ? (
          <Title>
            <Logo src="/images/gipsybot-happy.svg"></Logo>
            {translations.slack.appInstalled}
          </Title>
        ) : (
          <AddSlackContainer>
            <UpperContainer>
              <SlackLogo src="/images/slack_icon.svg"></SlackLogo>
              {'+'}
              <GipsyLogo src="/images/gb-logo.png"></GipsyLogo>
            </UpperContainer>
            <AddSlackTitle>{translations.settings.section.apps.section.slackApp.smartDetectText}</AddSlackTitle>
            <AddToSlackButtonContainer href={slackAuthUrl} target="_blank">
              {translations.slack.addToSlack}
            </AddToSlackButtonContainer>
          </AddSlackContainer>
        )}
        <Subtitle>{translations.slack.messageAction}</Subtitle>
        <StyledImage alt={'message-action-image'} src={getSrc('/images/slack-messageAction.png')} />
        <Subtitle>{translations.slack.slashCommand}</Subtitle>
        <StyledImage alt={'message-slash-command'} src={getSrc('/images/slack-slashCommand.png')} />
        <Subtitle>{translations.slack.taskDetection}</Subtitle>
        <StyledImage alt={'message-task-detection'} src={getSrc('/images/slack-taskDetection.png')} />
      </Container>
    )
  }
}

const titleWidth = 750
const textWidth = 640

const paddingLateral = (titleWidth - textWidth) / 2

const textTitleCss = css`
  color: ${styles.colors.textDarkColor};
  font-size: 24px;
  font-weight: 500;
  ${media['phone-wide']`
      font-size: 16px;
`}
`

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 20px;
  margin-bottom: 60px;

  ${media['phone-wide']`
      margin-top:0;
      padding:10px;
`}
`

const AddSlackContainer = styled.div`
  max-width: ${titleWidth}px;
  border-radius: 15px;
  text-align: center;
  background-color: white;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`

const UpperContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
`

const SlackLogo = styled.img`
  width: 48px;
  height: 48px;
  margin: 20px;
`

const GipsyLogo = styled.img`
  width: 64px;
  height: 64px;
  margin: 20px;
`

const AddSlackTitle = styled.div`
  ${textTitleCss}
  margin-bottom: 20px;
  padding-left: ${paddingLateral}px;
  padding-right: ${paddingLateral}px;
`

const AddToSlackButtonContainer = styled.a`
  && {
    display: flex;
    flex-direction: column;
    background-color: ${styles.colors.primaryColor};
    color: white;
    padding: 10px 15px;
    border-radius: 15px;
    font-size: 18px;
    font-weight: 500;
    margin-bottom: 30px;
    text-decoration: none;
    cursor: pointer;
  }
`

const Title = styled.div`
  margin-top: 50px;
  max-width: ${titleWidth}px;
  border-radius: 15px;
  background-color: white;
  ${textTitleCss}
  text-align: center;
  position: relative;
  padding-left: ${paddingLateral}px;
  padding-right: ${paddingLateral}px;
  padding-top: 70px;
  padding-bottom: 50px;
`

const Logo = styled.img`
  && {
    position: absolute;
    top: -50px;
    width: 100px;
    left: 50%;
    margin-left: -50px;
  }
`
const Subtitle = styled.div`
  max-width: ${textWidth}px;
  margin-top: 50px;
  ${textTitleCss}
  text-align: center;
`

const StyledImage = styled.img`
  margin-top: 50px;
  width: 750px;
`

export default SlackLandingPage



// WEBPACK FOOTER //
// ./src/pages/slackLandingPage/index.js